import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Work Sans", sans-serif;
  }

  html {
    font-size: 62.5%;
    /* scroll-behavior: smooth; */
    /* 1rem = 10px */
    // overflow-x: hidden;
  }

  body {
    ${'' /* background: ${({theme}) => theme.colors.bg}; */}
    background: white;
    // position: relative;
  }
  ::-webkit-scrollbar {
    width: 3px;
    height: 7px;
  }
  ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  }
  ::-webkit-scrollbar-thumb {
      background-color: ${({theme}) => theme.colors.primary};
      outline: 1px solid slategrey;
      border-radius: 1.5px;
  }
  p {
    font-size: 1.65rem;
  }
  a {
    text-decoration: none;
  }
  
  li {
    list-style: none;
  }

  ${"" /* resuable code section  */}
  .grid {
    display: grid;
    // gap: 9rem;
  }
  
  .grid-two-column {
    grid-template-columns: repeat(2, 1fr);
  
  }
  
  .grid-three-column {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .grid-four-column{
     grid-template-columns: 1fr 1.2fr .5fr .8fr ;
  }
  
  .grid-five-column{
    grid-template-columns: repeat(5, 1fr);
  }

  .link {
    text-decoration: none;
  }
  .loading-spiner {
    display: grid;
    place-items: center;
    margin-top: 25rem;
  }

  @keyframes zoom-pop {
    0% {
        opacity: 0;
        transform: scale(0.75); 
    }
    50% {
      opacity: 1;
      transform: scale(1.025);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
  }
  @keyframes slide-down {
    from {
        opacity: 0;
        transform: translateY(4rem);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
  }
  @keyframes slow-expand {
    from {
      /* background-color: red; */
      display: none;
      max-height: 0;
      position: relative;
    }
    to {
      /* background-color: yellow; */
      display: table-row;
      max-height: 100%;
      position: relative;
    }
  }
  
`;